import React, { useContext, useEffect } from 'react'
import { IUserContextType, UserContext } from '~utils/context/UserContext'
import { checkPingTokenExpiry, initAuth } from '~utils/forgerock'
import {
  ENVIRONMENT_VARIABLES,
  FORGEROCK_FORGOT_PASSWORD_STAGES,
  FORGOT_PASSWORD_JOURNEY,
  FORGOT_PASSWORD_TITLE,
  FR_URL,
} from '~utils/constants'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import CustomSkeletonLoader from '~components/CustomSkeletonLoader/CustomSkeletonLoader'
import SessionExpire from '~components/SessionExpire/SessionExpire'
import { StepType } from '@forgerock/javascript-sdk'
import UnknownError from '~components/UnknownError/UnknownError'
import CollectUserNameForm from '~components/CollectUserNameForm/CollectUserNameForm'
import OTPChannelSelectForm from '~components/shared/OTPChannelSelectForm/OTPChannelSelectForm'
import OTPCollectForm from '~components/shared/OTPCollectForm/OTPCollectForm'
import ResetPassword from '~components/shared/ResetPassword/ResetPassword'
import RetrieveChangePasswordSuccess from '~components/RetrieveChangePasswordSuccess/RetrieveChangePasswordSuccess'

const ForgotPasswordJourney = () => {
  const { step, nextStep, isLoading, frSessionTimeout, env, storeToken, setStoreToken, setStep } =
    useContext(UserContext) as IUserContextType
  const location = useLocation()
  const token = storeToken ? storeToken : location?.state?.storeToken

  useEffect(() => {
    const initializeJourney = async () => {
      if (token && env) {
        setStoreToken(token)
        initAuth(FORGOT_PASSWORD_JOURNEY, token, ENVIRONMENT_VARIABLES[env][FR_URL])
        nextStep(undefined)
      } else {
        setStep(undefined)
      }
    }
    initializeJourney()
  }, [token, env])

  const stage: string = step?.payload?.stage

  const stepComponent = () => {
    switch (stage) {
      case FORGEROCK_FORGOT_PASSWORD_STAGES.FORGOT_PASSWORD_USERNAME:
        return <CollectUserNameForm key="CollectUserNameForm" />
      case FORGEROCK_FORGOT_PASSWORD_STAGES.FORGOT_PASSWORD_OTP_DELIVERY_CHANNEL:
        return <OTPChannelSelectForm key="OTPChannelSelectForm" />
      case FORGEROCK_FORGOT_PASSWORD_STAGES.FORGOT_PASSWORD_COLLECT_OTP:
        return <OTPCollectForm key="OTPCollectForm" />
      case FORGEROCK_FORGOT_PASSWORD_STAGES.FORGOT_PASSWORD_RESET:
        return <ResetPassword key="ResetPassword" />
      default:
        return
    }
  }

  return (
    <>
      {isLoading ? (
        <CustomSkeletonLoader />
      ) : (
        <>
          <Helmet>
            <title>{FORGOT_PASSWORD_TITLE}</title>
          </Helmet>

          {(step === undefined ||
            (step?.type === StepType.Step &&
              !Object.values(FORGEROCK_FORGOT_PASSWORD_STAGES).includes(stage))) &&
            !checkPingTokenExpiry() &&
            !frSessionTimeout && <UnknownError />}

          {step?.type === StepType.Step && (checkPingTokenExpiry() || frSessionTimeout) && (
            <SessionExpire token={token} />
          )}

          {step?.type === StepType.Step &&
            !checkPingTokenExpiry() &&
            !frSessionTimeout &&
            stepComponent()}

          {step?.payload?.message && <div>{step?.payload?.message}</div>}
          {step?.type === StepType.LoginSuccess && <RetrieveChangePasswordSuccess />}
        </>
      )}
    </>
  )
}

export default ForgotPasswordJourney
